import {FC, useEffect} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import {useRejectAssetsRequest} from "../../../hooks/dialogs/useRejectAssetsRequest";
import {useMainTranslation} from "../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";

export const RejectAssetRequestDialog: FC = () => {
    const {t, tCommon} = useMainTranslation('', {keyPrefix: 'pathPhysicalAssets.pathIncomingRequests'});
    const {
        isOpen, isLoading,
        handleClose,
        formik,
    } = useRejectAssetsRequest();

    useEffect(() => {
        formik.resetForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    return (
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>{t('Reject request')}</DialogTitle>
            <DialogContent sx={{gap: '10px',display: 'flex', flexDirection: 'column'}}>
                <Typography variant={'*bodyText2'}>{t('Please provide reject reason.')}</Typography>
                <TextField
                    multiline
                    rows={4}
                    label={'Comment'}
                    required
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.comment}
                    name={'comment'}
                    error={Boolean(formik.errors.comment)}
                    helperText={formik.errors.comment}
                />

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} size={'small'} variant={'text'}>{tCommon('Cancel')}</Button>
                <LoadingButton
                    variant={'contained'}
                    onClick={formik.submitForm}
                    disabled={!formik.isValid}
                    loading={isLoading}
                    size={'small'}
                >
                    {tCommon('Reject')}
                </LoadingButton>

            </DialogActions>
        </Dialog>
    )
}
